<app-pop-up-notification
    #conflictNotification
    [message]="'trend-graph.create-graph.error.max-graphs'"
    [closeButton]="'dlg.signin.close'"
    [hideTimeout]="null"
></app-pop-up-notification>

<div
    *ngIf="!responsive.isXLarge() && !showGraphPage"
    [ngClass]="[
        'top-container',
        responsive.deviceAndOrientation,
        responsive.screenSize,
    ]"
>
    <ng-container *ngTemplateOutlet="titleInputTemplate"> </ng-container>
    <div
        [ngClass]="[
            'button-container',
            responsive.deviceAndOrientation,
            responsive.screenSize,
        ]"
    >
        <ng-container *ngTemplateOutlet="buttonContainer"></ng-container>
    </div>
</div>

<div [ngClass]="['create-graph-main', responsive.screenSize]">
    <div
        [ngClass]="['content-left', responsive.screenSize]"
        [class]="!showGraphPage ? '' : 'hidden'"
    >
        <!-- Title Box -->
        <div data-cy="trend-graph-editable-title" class="title-box-no-gap">
            <div *ngIf="responsive.isXLarge()">
                <ng-container *ngTemplateOutlet="titleInputTemplate">
                </ng-container>
            </div>
        </div>

        <div
            class="custom-page-textarea-container custom-page-textarea-container-margin"
        >
            <div class="custom-page-textarea-label">
                {{ "trend-graph.create-graph.description.title" | translate }}
            </div>
            <app-textarea
                style="height: 100%"
                data-cy="trend-graph-description"
                [customClass]="'custom-page-textarea'"
                [placeholder]="
                    'trend-graph.create-graph.description.placeholder'
                "
                [value]="view.description"
                (onValueChange)="editDescription($event)"
                [maxlength]="255"
            />
        </div>

        <!-- Share Settings -->
        <app-page-share-settings
            [ngClass]="['share-settings-wrapper', responsive.screenSize]"
            [isPublic]="editedView.publicAccess"
            [usersAccess]="usersAccess"
            [isCreating]="isEditing ? false : true"
            (onAccessChanged)="handleAccessChanged($event)"
            (onUserPermissionChanged)="handleUserAccessChanged($event)"
        ></app-page-share-settings>

        <app-search-channel-group
            [ngClass]="['search-group-wrapper', responsive.screenSize]"
            [page]="pageTitle"
            (onChannelsSelected)="toggleSelectedChannels($event)"
            [editChannels]="view.channels"
            (onLoadingComplete)="onLoadingCompleted()"
            (onShowPreview)="onShowGraphPage()"
            #searchChannelComponent
        >
        </app-search-channel-group>
    </div>

    <!-- Graph Preview -->
    <div
        [ngClass]="['graph-preview-container', responsive.screenSize]"
        [class]="isLargeScreen() || showGraphPage ? '' : 'hidden'"
    >
        <p *ngIf="!showGraphPage">
            {{ "trend-graph.labels.graph-preview" | translate }}
        </p>
        <button
            *ngIf="showGraphPage"
            (click)="onCloseGraphPreview()"
            [ngClass]="[
                'close-button',
                responsive.deviceAndOrientation,
                responsive.screenSize,
            ]"
        >
            {{ "trend-graph.graph-preview.button.close" | translate }}
        </button>
        <div style="position: relative">
            <app-channel-graph
                *ngIf="view != null"
                style="position: relative; left: -25px; min-width: 100%"
                [view]="editedView"
                [onDataUpdate]="onChannelValueUpdate"
                [(displayMinXIndex)]="dateRange.startIndex"
                [(displayMaxXIndex)]="dateRange.endIndex"
                [graphMinHeight]="graphMinHeight"
            ></app-channel-graph>
            <div
                *ngIf="!isAtDefaultZoom()"
                class="icon-reset"
                (click)="resetZoom()"
                style="position: absolute; right: 5px; top: 5px"
            ></div>
        </div>
        <div class="selected-channels-container">
            <p data-cy="trend-graph-selected-channels-label">
                {{
                    "trend-graph.labels.add-channel-prompt"
                        | translate: { max: MAX_CHANNELS }
                }}
            </p>
            <div *ngIf="isChannelLoadingComplete" class="selected-channels">
                <div
                    data-cy="trend-graph-channel-badge"
                    class="channel-bubble"
                    *ngFor="let channel of selectedChannels"
                    (click)="removeChannel(channel)"
                >
                    <span>{{ channel.name }}</span>
                    <span
                        data-cy="trend-graph-channel-badge-x-icon"
                        class="icon-cancel-close"
                    ></span>
                </div>
            </div>
        </div>
        <div *ngIf="responsive.isXLarge()" class="button-container">
            <ng-container *ngTemplateOutlet="buttonContainer"></ng-container>
        </div>
    </div>
</div>

<ng-template #buttonContainer>
    <button
        data-cy="trend-graph-cancel-button"
        (click)="cancel()"
        class="cancel-button"
    >
        {{ "trend-graph.buttons.cancel-graph" | translate }}
    </button>
    <button
        data-cy="trend-graph-save-button"
        (click)="submit()"
        [disabled]="!checkRequiredConditions()"
        class="create-button"
    >
        {{
            (isEditing
                ? "trend-graph.buttons.update-graph"
                : "trend-graph.buttons.create-graph"
            ) | translate
        }}
    </button>
</ng-template>

<ng-template #titleInputTemplate>
    <div style="flex: 1; width: 100%">
        <div>
            <div style="position: relative">
                <input
                    [(ngModel)]="editedView.name"
                    type="text"
                    [ngClass]="[
                        'title-input',
                        responsive.deviceAndOrientation,
                        responsive.screenSize,
                    ]"
                    (input)="handleTitleChange()"
                    (click)="$event.stopPropagation()"
                    value=""
                    maxlength="32"
                    autocomplete="off"
                    [placeholder]="
                        'trend-graph.create-graph.title.placeholder' | translate
                    "
                    (focus)="displaySuggestions = true"
                />
                <app-used-titles-suggestions
                    *ngIf="displaySuggestions"
                    [titleList]="getTitleList()"
                    (onHideSuggestions)="displaySuggestions = false"
                    (onTitleSelected)="
                        editedView.name = $event; handleTitleChange()
                    "
                ></app-used-titles-suggestions>
            </div>

            <app-validation-error-label
                *ngIf="titleIsRepeated() || editedView.name?.trim().length == 0"
                [message]="titleError"
            ></app-validation-error-label>
        </div>
    </div>
</ng-template>

<div class="loading-spinner-container" *ngIf="!isChannelLoadingComplete">
    {{ "general.notification.retreiving-data" | translate }}
    <app-loading-spinner
        style="height: 200px; width: 200px"
    ></app-loading-spinner>
</div>
